import React from "react";
import { useTranslation } from "react-i18next";

const stripColon = (label) =>
  typeof label === "string" ? label.replace(/\s*:\s*$/, "") : label;

const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  value === "" ||
  (Array.isArray(value) && value.length === 0);

/**
 * Bordered card with a title band and a zebra label/value table.
 * rows: [{ label, value, hide }]  (value may be a string or a React node)
 * columns: 1 (label | value) or 2 (label | value | label | value)
 */
const DetailCard = ({ title, rows = [], columns = 1, className = "", children, empty }) => {
  const { t } = useTranslation();
  const visible = rows.filter((r) => r && !r.hide);

  const cell = (row, key) => (
    <React.Fragment key={key}>
      <th scope="row" className="appt-card__label">
        {stripColon(row.label)}
      </th>
      <td className="appt-card__value">{isEmpty(row.value) ? t("common.nA") : row.value}</td>
    </React.Fragment>
  );

  let body;
  if (children) {
    body = <div className="appt-card__body">{children}</div>;
  } else if (visible.length === 0) {
    body = <div className="appt-card__body appt-card__empty">{empty || t("common.nA")}</div>;
  } else if (columns === 2) {
    const pairs = [];
    for (let i = 0; i < visible.length; i += 2) pairs.push(visible.slice(i, i + 2));
    body = (
      <table className="appt-card__table appt-card__table--two">
        <tbody>
          {pairs.map((pair, i) => (
            <tr key={i}>
              {cell(pair[0], `${i}-a`)}
              {pair[1] ? cell(pair[1], `${i}-b`) : <td className="appt-card__filler" colSpan={2} />}
            </tr>
          ))}
        </tbody>
      </table>
    );
  } else {
    body = (
      <table className="appt-card__table">
        <tbody>
          {visible.map((row, i) => (
            <tr key={i}>{cell(row, i)}</tr>
          ))}
        </tbody>
      </table>
    );
  }

  return (
    <section className={`appt-card ${className}`}>
      {title && <h3 className="appt-card__title">{title}</h3>}
      {body}
    </section>
  );
};

export default DetailCard;
